import { useContext } from 'react'
import { OAuthContext } from './OAuthContext'

const useOAuthContext = () => useContext(OAuthContext)

export default useOAuthContext
